/**
 * This is the main page after the use logs in
 */
import * as React from 'react';
import { Page } from './base/page';
import { Heading1 } from '../ap/base/text';
import * as gls from '../ap/layout/gls';
import * as typestyle from 'typestyle';
import * as csx from 'csstips';
import * as styles from '../ap/base/styles';
import { route, linkTo, redirectTo } from '../links';
import { Hr } from '../ap/base/hr';
import { MaxWidthReef, SectionStyles } from '../ap/pages/sections';
import { VoiIcon, DocumentStoreIcon, DocumentSightingIcon } from '../icons/appIcons';
import { SecondaryButton } from '../ap/base/button';
import { NotificationBar, Status} from '../pages/components/notificationBar';
import { appState } from '../state/state';
const {voi} = appState;
import { trackDashboardPage, trackLinkClick } from '../ap/omniture/omnitureService';
import { config } from '../config/config';

namespace OptionStyles {
  export const rootClassName = typestyle.style(
    csx.vertical,
    csx.flex,
    csx.center,
    csx.centerJustified,
    SectionStyles.islandBorderStyle,
    {
      textAlign: 'center',
      textDecoration: 'none',
      padding: '50px 5px',
      transition: 'color .2s, background-color .2s',
      color: styles.colors.grey,

      backgroundColor: 'white',
    }
  );
}
const Option = ({
  text,
  link,
  icon,
  buttonText,
  targetText,
  id,
  onClick,
}: { text: string, icon: React.ReactNode, link: string, buttonText: string, targetText: string, id?: string, onClick?: any}) => {
  return <a className={OptionStyles.rootClassName} href={link} target={targetText} onClick={onClick}>
    <div>
      {icon}
    </div>
    <gls.SmallVerticalSpace space={10}/>
    <div style={{fontSize: '18px'}}>
      {text}
    </div>
    <gls.SmallVerticalSpace space={20}/>
    <div>
      <SecondaryButton text={buttonText} id={id}/>
    </div>
  </a>
}
class Messages
{
    static SuccessMessage: string = "Payment was successful. You'll receive an email when your VOI document is ready to view.";
    static FailureMessage: string = "Payment error! Looks like our website is experiencing some technical issues right now. Please try again later.";
}
interface DashPageProps{
}

interface DashPageState{
}

export class Dash extends React.Component<DashPageProps, DashPageState>{

  constructor(props) {
    super(props);
    window.location.href = config.portalConfig.portalLoginUrl;
  }

  componentDidMount() {
    trackDashboardPage();
  }

  render() {
    const omnitureOnClickPerformVoiCheckStart = () => trackLinkClick('diy dashboard', 'perform voi check start');
    const omnitureOnClickVoiReportPortalAccess = () => trackLinkClick('diy dashboard', 'voi report portal access');

    return (
    <Page
      loggedIn={true}
      sections={[
        <MaxWidthReef>
          <NotificationBar type={Status.success} show={(voi.transactionStatus.value == Status.success)} message={Messages.SuccessMessage} />
          <NotificationBar type={Status.failure} show={(voi.transactionStatus.value == Status.failure)} message={Messages.FailureMessage} />
        </MaxWidthReef>,
        <MaxWidthReef>
          <gls.ContentHorizontal>
            {
              /** Disabled ElectronicVerification
                <Option link={linkTo(route.registerNew())} text="Electronic Verification" icon={<VoiIcon />} buttonText="Start" />
                <gls.SmallHorizontalSpace space={20} />
              */
            }
            <Option link={linkTo(route.registerNew())} text="Perform VOI check" icon={<DocumentSightingIcon />} buttonText="Start" targetText="_self" id="documentSightingButton" onClick={omnitureOnClickPerformVoiCheckStart}/>
            <gls.SmallHorizontalSpace space={20} />
            <Option link={config.portalConfig.portalLoginUrl} text="VOI report portal" icon={<DocumentStoreIcon />} buttonText="Access" targetText="_blank" onClick={omnitureOnClickVoiReportPortalAccess}/>
          </gls.ContentHorizontal>
        </MaxWidthReef>
      ]} />
  );}
}
